export default __webpack_public_path__ + "static/media/Mariska_Reyneke.5eeabef2.jpeg";